var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vs-list--header",class:[`vs-header-list-${_vm.color}`,{
    'with-icon':_vm.icon,
  }],style:(_vm.styleHeader)},[(_vm.icon)?_c('div',{staticClass:"vs-list--icon"},[_c('vs-icon',{attrs:{"icon":_vm.icon,"icon-pack":_vm.iconPack}})],1):_vm._e(),_c('div',{staticClass:"list-titles"},[(_vm.title)?_c('div',{staticClass:"vs-list--title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._t("title")],2),_c('div',{staticClass:"vs-list--slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }